var React = require( 'react' );
var createReactClass = require('create-react-class');
var NavListItem = require('./navListItem.jsx');

var BodyPartList = createReactClass({

  render: function(){
		var list = this.props.bodyParts.map(function (bodypart, i) {
			return (
				<NavListItem
				  key={i}
				  type="bodypart"
				  bodyParts={bodypart.friendlyUrl}
				  cssId={bodypart.friendlyUrl}
				  url={'bodyparts/' + bodypart.friendlyUrl}
				  title={bodypart.displayName}
				  clickTracking={this.props.clickTracking} />
			);
		}.bind(this));

		return (
			<li className={'orbit-slide' + (this.props.isActive ? ' is-active' : '')} id={this.props.id}>
				<ul className="special-menu-list" id="body-parts">
					{list}
				</ul>
			</li>
		);
	}
});

module.exports = BodyPartList;



// WEBPACK FOOTER //
// ./src/common/routes/education/components/layout/bodyPartList.jsx